import React, { Component } from 'react';
import PanelHolder from '../model/PanelHolder.js';
import { listenTo, clearBindings } from '../util/Utility.js';

export default class BugView extends Component {

  fetchObjects(limit, callback) {
    listenTo("bugs", this, callback);
  }

  componentWillUnmount() {
    clearBindings();
  }

  render() {
    return (<center>
      <h3>User Reported Bugs and Feature Requests</h3>
      <p>These are submitted by members of the congregation</p>
      <PanelHolder type="bugs" sortFunc={(a, b) => a.date && b.date ? b.date - a.date : 1 } fetchObjects={this.fetchObjects.bind(this)} {...this.props} />
    </center>);
  }
}



/** WEBPACK FOOTER **
 ** ./src/bugs/BugView.js
 **/